import BranchLandingPage from "@/components/branch/BranchLandingPage";
import { paintersPlasterersPage } from "@/data/branchLandingPages";

const WerkkledingSchildersStukadoors = () => (
  <BranchLandingPage page={paintersPlasterersPage} />
);

export default WerkkledingSchildersStukadoors;